import React, {Component} from 'react';
import {
  Button,
  Table
} from 'reactstrap';

import BtnsEstado from './BtnEstadoBlog';

import { FaPencilAlt, FaTrashAlt, FaEye} from 'react-icons/fa';

import UrlBase from './../api/UrlBase';


import Blog from './../api/Blog';

const blog = new Blog();

class TablaBlog extends Component {

    cambiaEstado = async (id, estado) => {
        let nuevoEstado = estado==='borrador' ? 'publicada' : 'borrador'; 
        let resultado = await blog.cambioEstado(id, nuevoEstado)
        if(resultado==="ok"){console.log("estado cambiado")}
        this.props.cargarListado(); 
    }

    render(){
        const {visualizar, data,  editar  , eliminar} = this.props; 

        return (
            <div>
                {data.length>0 ? (
                    <Table size="sm" striped bordered className="tabla-general tabla-blog">
                        <thead>
                            <tr>
                                <th className="ocultar-en-somen">Título</th>
                                <th className="ocultar-en-somen">Encabezado - Contenido</th>
                                <th className="ocultar-m-omas mostrar-en-s-table">hola</th>
                                <th className="text-center ocultar-en-somen">Imagen</th>
                                <th >Estado</th>
                                <th className="text-center">Opciones</th>
                            </tr>
                        </thead>
                        <tbody>
                        {data.map(b => {
                                return (
                                    <tr key={b.id}>
                                        <td className="ocultar-en-somen">{b.titulo}</td>
                                        <td className="ocultar-en-somen">
                                            <div>
                                            {b.encabezado}
                                            </div>
                                            <hr/>
                                            <div>
                                                {b.contenido}
                                            </div>
                                        </td>
                                        <td className="ocultar-m-omas mostrar-en-s-table">
                                            <div>
                                                {b.titulo}
                                            </div>
                                            <hr/>
                                            <div>
                                                {b.encabezado}
                                            </div>
                                            <hr/>
                                            <div>
                                                {b.contenido}
                                            </div>
                                        </td>
                                        <td className="ocultar-en-somen">
                                        <img src={UrlBase+b.imagen} alt="" className="imagen-tabla bloque-centro" />
                                        </td>
                                        <td>
                                            
                                            <BtnsEstado  estado={b.estado} cambia={()=>this.cambiaEstado(b.id, b.estado)}/>
                                                                        
                                        </td>
                                        <td className="text-center td-botones">
                                            <Button color="info" className="btn-tabla"  onClick={()=>visualizar(b)}  > <FaEye/></Button>
                                            <Button color="secondary" className="btn-tabla"  onClick={()=>editar(b)} > <FaPencilAlt/></Button>
                                            <Button color="danger" className="btn-tabla"  onClick={()=>eliminar(b.id)} ><FaTrashAlt/></Button>
                                        </td>
                                    </tr>
                                )  
                            })} 


                        </tbody>

                    </Table>
                    ) : (<div className="sin-registros">Sin registros</div>)  
                }             
            </div>
        );

    }
};

export default TablaBlog;
